import React, { memo, useEffect, useState } from "react";
import { logWebHook } from "../../../../api";
import ReactPaginate from "react-paginate";
import { Table } from "react-bootstrap";

const WebhookLogs = ({ organizationId }) => {
    const [webhooklogs, setWebhooklogs] = useState([]);
    const [totalCount, setTotalCount] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    useEffect(() => {
        logWebHook({ organizationId: organizationId })
            .then((res) => {
                if (res.status) {
                    setWebhooklogs(res.data.data);
                    setTotalCount(res.data.total);
                    setCurrentPage(res.data.current_page);
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    const handlePageClick = (data) => {
        logWebHook({
            organizationId: this.props.organizationId,
            page: data.selected + 1,
        })
            .then((res) => {
                setWebhooklogs(res.data.data);
                setTotalCount(res.data.total);
                setCurrentPage(res.data.current_page);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    return (
        <div className="ml-3">
            <br></br>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Status</th>
                        <th>Response</th>
                        <th>Date time</th>
                    </tr>
                </thead>
                <tbody>
                    {webhooklogs.length > 0 &&
                        webhooklogs.map((item) => (
                            <tr key={item.id}>
                                <td>{item.id}</td>
                                <td>{item.status_code}</td>
                                <td>{item.response}</td>
                                <td>{item.created_at}</td>
                            </tr>
                        ))}
                </tbody>
            </Table>

            <div className="webbook-pagination-area">
                <ReactPaginate
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={Math.ceil(totalCount / 10)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination pagination-webbook"}
                    activeClassName={"active"}
                />
            </div>
        </div>
    );
};

WebhookLogs.defaultProps = {};

export default memo(WebhookLogs);
